import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect, useRef } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { spotifyTrack, captureUtm, gaPageview } from "@/lib/tracking";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import AuthCallback from "@/pages/AuthCallback";

function AppRouter() {
  const location = useLocation();
  const firstRender = useRef(true);
  const lastPath = useRef(window.location.pathname);

  useEffect(() => {
    // index.html base pixel + gtag config fire the initial view; track SPA route changes here
    if (firstRender.current) {
      firstRender.current = false;
      captureUtm();
    }
    if (lastPath.current === location.pathname) return;
    lastPath.current = location.pathname;
    spotifyTrack("view");
    gaPageview(location.pathname);
  }, [location.pathname]);

  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
